import React from 'react';
import { useParams } from 'react-router-dom';
import StaticLayout from '@components/layout/StaticLayout';
import LeftPanel from './sections/LeftPanel';
import MainColumn from './sections/MainColumn';
import { useQuery } from '@apollo/client';
import {
  getAmendmentMainDetailsQuery,
  getCancellationAmendmentDetails,
} from './queries';
import { toast } from 'react-toastify';
import ToastErrorMessage from '@components/toast/ToastErrorMessage';
import { getError } from '@utils/graph-utils';
import Loader from '@components/loader/Loader';

const AmendmentDetailsPage: React.FC = () => {
  const { id: currentAmendmentId } = useParams<{ id: string }>();

  const {
    refetch: refetchMain,
    data: mainData,
    error: mainError,
    loading: mainLoading,
  } = useQuery(getAmendmentMainDetailsQuery, {
    variables: { selectedAmendmentID: currentAmendmentId },
    errorPolicy: 'all',
  });

  const amendmentDetails = mainData?.Production?.queries?.getAmendmentDetails;
  const amendmentType =
    amendmentDetails?.[0]?.production_Amendment_AmendmentType;

  const skipCancellation = !mainData || amendmentType !== 'POLICY_CANCELLATION';
  const {
    data: cancellationData,
    error: cancellationError,
    loading: cancellationLoading,
    refetch: refetchCancellation,
  } = useQuery(getCancellationAmendmentDetails, {
    variables: { selectedAmendmentID: currentAmendmentId },
    skip: skipCancellation,
    errorPolicy: 'all',
  });

  if (mainError) {
    toast.error(
      <ToastErrorMessage>{getError({ errors: mainError })}</ToastErrorMessage>
    );
  }
  if (cancellationError) {
    toast.error(
      <ToastErrorMessage>
        {getError({ errors: cancellationError })}
      </ToastErrorMessage>
    );
  }

  if (
    mainLoading ||
    (amendmentType === 'POLICY_CANCELLATION' && cancellationLoading)
  ) {
    return <Loader />;
  }

  const queryData =
    amendmentType === 'POLICY_CANCELLATION' ? cancellationData : mainData;

  return (
    <StaticLayout
      name={'Proposal Details'}
      leftChildren={
        <LeftPanel
          data={
            amendmentType === 'POLICY_CANCELLATION'
              ? cancellationData?.Production?.queries
                  ?.getCancellationAmendmentDetails?.[0]
              : amendmentDetails?.[0]
          }
        />
      }
      mainChildren={
        <MainColumn
          data={queryData}
          onSuccess={() => {
            amendmentType === 'POLICY_CANCELLATION'
              ? refetchCancellation()
              : refetchMain();
          }}
        />
      }
    />
  );
};

export default AmendmentDetailsPage;
